/**
 * NPCConfig
 *
 * @deprecated Use `src/shared/config/npc.config.ts` directly
 * (`import { NPC } from '<path>/shared/config/npc.config'`).
 *
 * Backwards-compat shim re-exporting `NPC_DEFAULTS` (legacy ALL_CAPS
 * shape) from the new typed `NPC`. Migrate per-file at your leisure. See
 * `docs/plans/2026-04-25-CONFIG-MIGRATION.md`.
 */

import { NPC } from '../config/npc.config';

export const NPC_DEFAULTS = {
  DIMENSIONS: {
    DEFAULT_WIDTH: NPC.dimensions.defaultWidth,
    DEFAULT_HEIGHT: NPC.dimensions.defaultHeight,
  },
  TIMING: {
    RESPAWN_DELAY_MS: NPC.timing.respawnDelayMs,
  },
};
